import { Component, OnInit, OnDestroy } from '@angular/core';
import { FileService } from '@services/wiki/file.service';
import { EditorService } from '@services/wiki/editor.service';
import { AuthService } from '@services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';
import { LicenceRoleType } from '@enums/licence-role-type.enum';

@Component({
  selector: 'app-editor-container',
  templateUrl: './editor-container.component.html',
  styleUrls: ['./editor-container.component.scss']
})
export class EditorContainerComponent implements OnInit, OnDestroy {

  private editModeSub: Subscription;
  private providerSub: Subscription;
  private firstPageSub: Subscription;

  private  provider: string = null;
  private isBizzDev = false;

  editable = false;
  chosenFilePath = '\\';
  chosenFileName: string;
  language: string;
  tabIndex = 0;
  selectedLanguage = "";
  languages: string[];

  constructor(
    private fileService: FileService,
    private editorService: EditorService,
    private authService: AuthService,
    private route: ActivatedRoute) {
   }

  ngOnInit() {
    this.initPage();
  }

  changeTab(event): void {
    this.tabIndex = event.index;
  }

  private initPage(): void {
    this.selectedLanguage = this.authService.getDecodedToken().language;
    const role = this.authService.getDecodedToken().role;
    this.isBizzDev = role === LicenceRoleType.bzd || role === LicenceRoleType.bko;
    this.route.paramMap.subscribe(params => {
      const editable = sessionStorage.getItem(environment.editable);
      if (editable === 'true' && this.isBizzDev) {
        this.editable = true;
      }
      if (params.get('path') && params.get('path') !== '') {
        this.chosenFilePath = decodeURIComponent(escape(atob(params.get('path'))));
      } else {
        this.firstPageSub = (this.fileService.getFirstPageSub().subscribe(url => {
          this.chosenFilePath = url;
        }));
      }
    });

    // this.fileService.getLanguages(this.provider).subscribe(lg => {
    //   this.languages = lg;
    // });

    this.editModeSub = (this.editorService.getEditMode().subscribe(mode => {
      if (this.isBizzDev) {
        this.editable = mode;
        this.tabIndex = 0;
      }
    }));

    this.providerSub = (this.fileService.getProviderSub().subscribe(provider => {
      this.provider = provider;
      this.fileService.getLanguages(this.provider).subscribe(lg => {
        this.languages = lg;
      });
    }));
  }
  ngOnDestroy(): void {
    if (this.editModeSub) {
      this.editModeSub.unsubscribe();
    }

    if(this.providerSub) {
      this.providerSub.unsubscribe();
    }

    if (this.firstPageSub) {
      this.firstPageSub.unsubscribe();
    }
  }

}
